import { render, staticRenderFns } from "./iconHome.vue?vue&type=template&id=84e71990"
import script from "./iconHome.vue?vue&type=script&lang=js"
export * from "./iconHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports